import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { Toaster } from "./components/ui/sonner";
import AuthCallback from "./components/AuthCallback";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Penerimaan from "./pages/Penerimaan";
import Pentasyarufan from "./pages/Pentasyarufan";
import Aset from "./pages/Aset";
import DatabasePage from "./pages/Database";
import Layanan from "./pages/Layanan";
import Laporan from "./pages/Laporan";
import Pengguna from "./pages/Pengguna";
import PublicDashboard from "./pages/PublicDashboard";
import Khitan from "./pages/Khitan";
import PinjamAlat from "./pages/PinjamAlat";
import LayananAmbulance from "./pages/LayananAmbulance";
import AnnualReport from "./pages/AnnualReport";
import KalkulatorZakat from "./pages/KalkulatorZakat";
import Qris from "./pages/Qris";
import InfoPage from "./pages/InfoPage";
import ReceiptVerify from "./pages/ReceiptVerify";
import SuratVerify from "./pages/SuratVerify";
import KartuSehat from "./pages/KartuSehat";
import Usg from "./pages/Usg";
import KartuVerify from "./pages/KartuVerify";
import LaporanVerify from "./pages/LaporanVerify";
import { Loader2 } from "lucide-react";

function LoadingScreen() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50" data-testid="app-loading">
      <Loader2 className="h-8 w-8 animate-spin text-emerald-800" />
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <LoadingScreen />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<PublicDashboard />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/khitan" element={<Khitan />} />
      <Route path="/pinjam-alat" element={<PinjamAlat />} />
      <Route path="/layanan-ambulance" element={<LayananAmbulance />} />
      <Route path="/annual-report" element={<AnnualReport />} />
      <Route path="/kalkulator-zakat" element={<KalkulatorZakat />} />
      <Route path="/qris" element={<Qris />} />
      <Route path="/info/:topic" element={<InfoPage />} />
      <Route path="/kwitansi/:txId" element={<ReceiptVerify />} />
      <Route path="/surat/:suratId" element={<SuratVerify />} />
      <Route path="/kartu-sehat" element={<KartuSehat />} />
      <Route path="/usg" element={<Usg />} />
      <Route path="/kartu/:cardId" element={<KartuVerify />} />
      <Route path="/verifikasi-laporan" element={<LaporanVerify />} />
      <Route
        element={
          <Protected>
            <Layout />
          </Protected>
        }
      >
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/penerimaan" element={<Penerimaan />} />
        <Route path="/pentasyarufan" element={<Pentasyarufan />} />
        <Route path="/aset" element={<Aset />} />
        <Route path="/database" element={<DatabasePage />} />
        <Route path="/layanan" element={<Layanan />} />
        <Route path="/laporan" element={<Laporan />} />
        <Route path="/pengguna" element={<Pengguna />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
        <Toaster richColors position="top-right" />
      </AuthProvider>
    </BrowserRouter>
  );
}
